<template>
  <div class="template-tabs-item">
    <div class="template-content">
      <div class="template-title">{{ row.title }}</div>
      <el-tooltip effect="dark" placement="top" :offset="30" :hide-after="100">
        <div class="template-description">{{ row.description || row.content }}</div>
        <template #content>
          <div class="tooltip-content-overflow">{{ row.description || row.content }}</div>
        </template>
      </el-tooltip>
    </div>
    <div class="template-footer">
      <div class="template-usage">★{{ row.useTimes ? row.useTime : null }}</div>
      <div class="template-actions">
        <template v-if="editAuth">
          <el-icon class="delete-button" @click="emits('clickItemFn', 'delete')">
            <DeleteFilled />
          </el-icon>
          <el-icon class="edit-button" @click="emits('clickItemFn', 'edit')">
            <EditPen />
          </el-icon>
        </template>
        <template v-else>
          <el-icon class="edit-button" @click="emits('clickItemFn', 'add')">
            <Plus />
          </el-icon>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue';
const emits = defineEmits(['clickItemFn']);

let props = defineProps({
  row: {
    type: Object,
    default: () => ({})
  },
  editAuth: {
    type: Boolean,
    default: true
  },
});
</script>

<style lang="scss" scoped>
$template-background: #1c1c1c;
$template-text: #ffffff;
$star-button-bg: #ffeb3b;
$star-button-hover-bg: #d4af37;
$delete-button-bg: #e57373;
$delete-button-hover-bg: #d32f2f;
$edit-button-bg: #9f7aea;
$edit-button-hover-bg: #805ad5;

.template-tabs-item {
  background-color: #2d2d3a;
  border: 1px solid #444;
  border-radius: 5px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  }

  .template-content {
    margin-bottom: 10px;

    .template-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 5px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .template-description {
      font-size: 14px;
      color: #ccc;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .template-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .template-usage {
      font-size: 14px;

      color: #888;
    }

    .template-actions {
      display: flex;
      gap: 5px;

      .star-button {
        background-color: $star-button-bg;
        color: $template-background;
        border: none;
        padding: 5px 10px;
        border-radius: 5px;
        cursor: pointer;
        transition: background-color 0.3s, transform 0.3s;

        &:hover {
          background-color: $star-button-hover-bg;
          transform: translateY(-2px);
        }
      }

      .delete-button {
        background-color: $delete-button-bg;
        border: none;
        padding: 5px;
        border-radius: 5px;
        cursor: pointer;
        transition: background-color 0.3s, transform 0.3s;

        &:hover {
          background-color: $delete-button-hover-bg;
          transform: translateY(-2px);
        }
      }

      .edit-button {
        background-color: $edit-button-bg;
        color: $template-text;
        border: none;
        padding: 5px;

        border-radius: 5px;
        cursor: pointer;
        transition: background-color 0.3s, transform 0.3s;

        &:hover {
          background-color: $edit-button-hover-bg;
          transform: translateY(-2px);
        }
      }
    }
  }
}

.tooltip-content-overflow {
  width: 300px;
  /* 设置一个固定的宽度 */
  max-height: 200px;
  word-wrap: break-word;
  white-space: normal;
  overflow: auto;
}
</style>
